import { Injectable } from '@angular/core';

const VIDEOCALL_PROMO_30_MIN = false;

@Injectable({
  providedIn: 'root'
})
export class CalendlyService {

  
  constructor() { }

  isVideocallPromoActive(){
    return VIDEOCALL_PROMO_30_MIN;
  }

  goToCalendlyLink(){
    if(VIDEOCALL_PROMO_30_MIN){
        window.open('https://calendly.com/voy-jaleas/30min?month=2023-02', '_blank');
    }else{
        window.open('https://calendly.com/voy-jaleas/voy-jaleas-consultoria?month=2025-08', '_blank');
    }
  }
  
}
